import React from "react";
import { Navigate } from "react-router-dom";

import useLocalStorage from "../components/hooks/useLocalStorage";
import Header from "../components/layout/Header";
import ReportsTable from "../components/tables/ReportsTable";

const Reports = (): JSX.Element => {
  const [reportsEnabled] = useLocalStorage("REPORTS_ENABLED", false);

  if (!reportsEnabled) {
    return <Navigate to="/reports/crypto-spread" />;
  }

  return (
    <>
      <Header title="Reports" />
      <ReportsTable />
    </>
  );
};

export default Reports;
